/* Livish audit fixes, part 3 (15 Oct 2026): filter carousel, filter menus follow their button,
   phone menu header, product card text alignment. Loaded after part 2. Remove this file and its
   line in layout/theme.liquid to roll back. */
/* Filter menus on phone and tablet stay right under their button while the
   page or the filter row scrolls. If the button leaves the screen, the menu
   closes instead of floating over the products. */
(function () {
  'use strict';
  var raf = 0;
  function place(d) {
    var s = d.querySelector('summary');
    if (!s) return;
    var r = s.getBoundingClientRect();
    var h = window.innerHeight;
    if (r.bottom < 0 || r.top > h || r.right < 0 || r.left > window.innerWidth) { d.removeAttribute('open'); return; }
    var top = Math.round(r.bottom + 8);
    d.style.setProperty('--lf-menu-top', top + 'px');
    d.style.setProperty('--lf-menu-maxh', Math.max(160, Math.min(h * 0.6, h - top - 16)) + 'px');
    // Tablet: the menu sits under its own button (phones use the full width).
    var m = d.querySelector('.t4s-livish-filter__menu');
    if (!m) return;
    if (window.innerWidth >= 768) {
      var w = Math.min(320, window.innerWidth - 32);
      var rtl = document.documentElement.dir === 'rtl';
      var x = rtl ? r.right - w : r.left;
      x = Math.max(16, Math.min(x, window.innerWidth - w - 16));
      m.style.setProperty('left', Math.round(x) + 'px', 'important');
      m.style.setProperty('right', 'auto', 'important');
      m.style.setProperty('width', w + 'px', 'important');
    } else {
      m.style.removeProperty('left'); m.style.removeProperty('right'); m.style.removeProperty('width');
    }
  }
  var anyOpen = false; // scrolling costs nothing while no filter menu is open
  function placeAll() {
    raf = 0;
    if (window.innerWidth > 1024) return;
    var open = document.querySelectorAll('[data-livish-filter-dropdown][open]');
    anyOpen = open.length > 0;
    for (var i = 0; i < open.length; i++) place(open[i]);
  }
  function queue() { if (anyOpen && !raf) raf = requestAnimationFrame(placeAll); }
  // capture: also catches the sideways scroll of the filter row
  document.addEventListener('scroll', queue, { capture: true, passive: true });
  window.addEventListener('resize', queue, { passive: true });
  // after the theme script places it on open (phone and tablet only)
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-livish-filter-dropdown]')) return;
    if (t.open) anyOpen = true;
    if (t.open && window.innerWidth <= 1024) setTimeout(function () { place(t); }, 0);
  }, true);
})();

/* Phone menu opens without the wait. The theme only downloads the menu on
   the first tap (search?view=mn), which shows a grey placeholder. This
   downloads it quietly once the page is idle (or as soon as the menu button
   is touched), keeps it for 15 minutes in this visit, and hands that same
   reply to the theme when it asks. If anything fails, the theme simply
   downloads the menu itself as before. */
(function () {
  'use strict';
  if (!window.fetch || !window.Response || !window.Promise) return;
  if (window.innerWidth > 1024 || !document.getElementById('t4s-menu-drawer')) return;
  if (window.T4Srequest && window.T4Srequest.design_mode) return;
  var root = (window.T4Sroutes && window.T4Sroutes.search_url) || '/search';
  var url = root + '?view=mn';
  var pv = location.search.match(/preview_theme_id=\d+/);
  if (pv) url += '&' + pv[0];
  function pathOf(u) { var a = document.createElement('a'); a.href = u; return a.pathname.replace(/\/$/, ''); }
  var path = pathOf(url);
  var key = 'lv_mn:' + ((window.T4Sconfigs && window.T4Sconfigs.cacheName) || '') + ':' + path;
  var TTL = 15 * 60 * 1000;
  var html = null, pending = null;
  try {
    var c = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (c && c.h && Date.now() - c.t < TTL) html = c.h;
  } catch (e) {}
  var origFetch = window.fetch;
  function looksRight(t) { return t && !/<html[\s>]/i.test(t) && t.indexOf('t4s-mb-tab__content') > -1; }
  function load() {
    if (html || pending) return;
    pending = origFetch.call(window, url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('menu ' + r.status); return r.text(); })
      .then(function (t) {
        if (!looksRight(t)) throw new Error('menu reply not as expected');
        html = t;
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), h: t })); } catch (e) {}
        return t;
      });
    pending.catch(function () { pending = null; });
  }
  window.fetch = function (input, init) {
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      var m = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = html ? Promise.resolve(html) : pending;
      if (p && m === 'GET' && /[?&]view=mn(?:[&#]|$)/.test(u) && pathOf(u) === path) {
        var self = this, args = arguments;
        return p.then(function (t) {
          return new Response(t, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } });
        }, function () { return origFetch.apply(self, args); });
      }
    } catch (e) {}
    return origFetch.apply(this, arguments);
  };
  if (html) return;
  // Touching the menu button starts the download straight away.
  document.addEventListener('touchstart', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-menu-drawer]')) load();
  }, { capture: true, passive: true });
  function idle() {
    if (window.requestIdleCallback) requestIdleCallback(load, { timeout: 3000 });
    else setTimeout(load, 1500);
  }
  if (document.readyState === 'complete') idle();
  else window.addEventListener('load', idle);
})();

/* Cart gift form: the recipient address box keeps a normal height (the gift
   app's own field styles made it very tall on phones). The style goes inside
   the app's box and is put back if the app redraws it. */
(function () {
  'use strict';
  var CSS = '.lvx-field textarea{height:78px!important;min-height:78px!important;max-height:180px}';
  function add(sr) {
    if (sr.getElementById('lv-wr-3')) return;
    var st = document.createElement('style');
    st.id = 'lv-wr-3';
    st.textContent = CSS;
    sr.appendChild(st);
  }
  function hook() {
    document.querySelectorAll('wrapped-extension').forEach(function (w) {
      var sr = w.shadowRoot;
      if (!sr) return;
      add(sr);
      if (!sr.__lv3) { sr.__lv3 = new MutationObserver(function () { add(sr); }); sr.__lv3.observe(sr, { childList: true }); }
    });
  }
  function init() {
    if (!/template-cart/.test(document.body.className)) return;
    hook();
    var main = document.getElementById('MainContent'), t = 0;
    if (main) new MutationObserver(function () { clearTimeout(t); t = setTimeout(hook, 200); }).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Cart feels instant.
   1. Add to cart (product cards, product page, quick view): the cart drawer
      opens on the tap with a loading bar and fills in when the store answers.
      Before, nothing moved until the answer came back (2-3 s on phones).
   2. Quantity buttons on product cards: the new number shows on the tap and
      the store is updated in the background (quick taps are sent as one).
   3. Remove in the cart drawer: the line folds away on the tap instead of a
      dark loading screen.
   If the store refuses (sold out, limit), the real cart is shown again. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function drawerEl() { return document.getElementById('t4s-mini_cart'); }
  function isCartPage() { return /template-cart/.test(document.body.className); }
  function drawerOpen() { var d = drawerEl(); return !!d && d.getAttribute('aria-hidden') === 'false'; }
  function openDrawer() {
    if (drawerOpen()) return true;
    var link = document.querySelector('.t4s-toolbart-cart a[data-drawer-options], a[data-drawer-options*="mini_cart"]');
    if (link) { link.click(); return drawerOpen(); }
    return false;
  }
  function closeDrawer() {
    try { if (drawerOpen() && window.T4SThemeSP && T4SThemeSP.Drawer) T4SThemeSP.Drawer.close(); } catch (e) {}
  }

  /* 1. Drawer opens on the tap. Success or failure is read from the store's
     answer to the add request itself (not from theme events, which some
     apps interrupt), so the drawer is never closed by mistake and never
     opens a second time. */
  var waiting = null, lastAdd = null, blockReopenUntil = 0;
  var fetchBefore = window.fetch;
  if (fetchBefore) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = fetchBefore.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        var rec = lastAdd = { at: Date.now(), status: 'pending', cbs: [] };
        var done = function (st) { rec.status = st; rec.cbs.splice(0).forEach(function (f) { f(st); }); };
        p.then(function (res) { done(res && res.ok ? 'ok' : 'fail'); }, function () { done('fail'); });
      }
      return p;
    };
  }
  // The older add-to-cart helper opens the drawer again after a success; once
  // the drawer has already been shown for this tap, that second open is skipped.
  document.addEventListener('click', function (e) {
    if (e.isTrusted || Date.now() > blockReopenUntil) return;
    if (!(e.target.closest && e.target.closest('a[data-drawer-options*="mini_cart"]'))) return;
    if (waiting && waiting.self) { waiting.self = false; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
  function startWait(btn) {
    var d = drawerEl();
    if (!d || isCartPage() || !(window.T4Sconfigs && T4Sconfigs.enableAjaxATC)) return;
    var w = waiting = { btn: btn, self: true };
    blockReopenUntil = Date.now() + 15000;
    if (!openDrawer()) { waiting = null; blockReopenUntil = 0; return; }
    w.self = false;
    var bar = d.querySelector(':scope > .lv-cart-wait-bar');
    if (!bar) { bar = document.createElement('div'); bar.className = 'lv-cart-wait-bar'; d.insertBefore(bar, d.firstChild); }
    d.classList.add('lv-cart-wait');
    w.timer = setTimeout(function () { endWait(w); }, 12000);
    var rec = lastAdd && Date.now() - lastAdd.at < 1500 ? lastAdd : null;
    if (!rec) return;
    var settle = function (st) {
      if (st === 'fail') { endWait(w); closeDrawer(); return; }
      // Answer is in; the theme fills the drawer right after. Fallback in case
      // its "cart updated" signal never comes.
      setTimeout(function () { endWait(w); }, 1500);
    };
    if (rec.status === 'pending') rec.cbs.push(settle); else settle(rec.status);
  }
  function endWait(w) {
    if (!w || w.done) return;
    w.done = true;
    clearTimeout(w.timer);
    if (waiting === w) waiting = null;
    var d = drawerEl();
    if (d && !waiting) d.classList.remove('lv-cart-wait');
  }
  document.addEventListener('cart:updated', function () {
    if (waiting) endWait(waiting);
    var d = drawerEl();
    if (d) d.classList.remove('lv-quick');
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-action-atc], [data-atc-form]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is--loading')) return;
    blockReopenUntil = 0;
    setTimeout(function () {
      // The theme marks the button as loading once its request has gone out.
      if (!btn.classList.contains('is--loading')) return;
      // Inside a popup (quick view) the theme closes the popup first; keep its own order there.
      if (!btn.closest('.mfp-wrap')) startWait(btn);
      var wrap = btn.closest('[data-livish-cart]');
      if (wrap) showQty(wrap, qtyOf(wrap) + 1);
    }, 0);
  }, true);

  /* 2. Card quantity buttons. */
  function qtyOf(wrap) {
    if (wrap.__lvQty != null) return wrap.__lvQty;
    var v = wrap.querySelector('[data-livish-qty-value]');
    return (v && parseInt(v.textContent, 10)) || 0;
  }
  function showQty(wrap, q) {
    var v = wrap.querySelector('[data-livish-qty-value]');
    if (v) v.textContent = q;
    wrap.classList.toggle('is--in-cart', q > 0);
    wrap.classList.toggle('is--single', q === 1);
    wrap.classList.remove('is--busy');
  }
  function resync(wrap) {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var q = 0, key = '';
        (cart.items || []).forEach(function (it) { if (String(it.product_id) === wrap.dataset.productId) { q += it.quantity; key = key || it.key; } });
        wrap.dataset.lineKey = key;
        wrap.__lvQty = null;
        showQty(wrap, q);
      }).catch(function () {});
  }
  function send(wrap) {
    if (wrap.__lvBusy) { wrap.__lvAgain = true; return; }
    wrap.__lvBusy = true;
    var want = wrap.__lvQty;
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: wrap.dataset.lineKey, quantity: want })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      wrap.__lvBusy = false;
      if (!res.ok) {
        if (window.T4SThemeSP && T4SThemeSP.Notices) T4SThemeSP.Notices(res.data.description || res.data.message || '');
        wrap.__lvAgain = false;
        resync(wrap);
        return;
      }
      if (wrap.__lvAgain || wrap.__lvQty !== want) { wrap.__lvAgain = false; send(wrap); return; }
      wrap.__lvQty = null;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function () { wrap.__lvBusy = false; wrap.__lvAgain = false; resync(wrap); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-livish-qty-change]');
    var wrap = btn && btn.closest('[data-livish-cart]');
    if (!wrap) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // handled here instead of the card's own script
    if (!wrap.dataset.lineKey) return;
    var next = Math.max(0, qtyOf(wrap) + (parseInt(btn.getAttribute('data-livish-qty-change'), 10) || 0));
    wrap.__lvQty = next;
    showQty(wrap, next);
    clearTimeout(wrap.__lvT);
    wrap.__lvT = setTimeout(function () { send(wrap); }, 300);
  }, true);

  /* 3. Remove in the cart drawer. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#t4s-mini_cart [data-cart-remove]');
    var item = btn && btn.closest('[data-cart-item]');
    if (!item || item.classList.contains('lv-removing')) return;
    var d = drawerEl();
    item.style.height = item.offsetHeight + 'px';
    item.classList.add('lv-removing');
    if (d) d.classList.add('lv-quick');
    requestAnimationFrame(function () { requestAnimationFrame(function () { item.style.height = '0px'; }); });
    // The theme takes "is--update" off the line when it is done; if the line is
    // still there, the store refused: show it again.
    var seen = false;
    var mo = new MutationObserver(function () {
      if (item.classList.contains('is--update')) { seen = true; return; }
      if (!seen) return;
      mo.disconnect();
      if (item.isConnected) { item.classList.remove('lv-removing'); item.style.height = ''; }
      if (d) d.classList.remove('lv-quick');
    });
    mo.observe(item, { attributes: true, attributeFilter: ['class'] });
    setTimeout(function () { mo.disconnect(); if (item.isConnected) { item.classList.remove('lv-removing'); item.style.height = ''; } if (d) d.classList.remove('lv-quick'); }, 12000);
  }, true);
})();

/* Wishlist page: the search box no longer shows the internal "id:..." list
   that the wishlist uses to find its products. */
(function () {
  function clear() {
    document.querySelectorAll('input[name="q"]').forEach(function (i) {
      if (/^\s*id:\s*\d/.test(i.value)) { i.value = ''; i.removeAttribute('value'); }
    });
  }
  if (!window.isPageWishlist && !/view=wishlist/.test(location.search)) return;
  clear();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clear);
  window.addEventListener('load', clear);
})();

/* Arabic pages: a few section buttons were typed in English in the theme
   settings (for example "View All" on the homepage). Show them in Arabic. */
(function () {
  if (!/^ar/i.test(document.documentElement.getAttribute('lang') || '')) return;
  var MAP = { 'view all': 'عرض الكل', 'view all products': 'عرض كل المنتجات', 'shop now': 'تسوّق الآن', 'shop all': 'تسوّق الكل' };
  function run() {
    document.querySelectorAll('a.t4s-btn, button.t4s-btn, .t4s-top-heading a').forEach(function (el) {
      for (var n = el.firstChild; n; n = n.nextSibling) {
        if (n.nodeType !== 3) continue;
        var ar = MAP[n.nodeValue.replace(/\s+/g, ' ').trim().toLowerCase()];
        if (ar) n.nodeValue = ar;
      }
    });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();

/* Product-row banners (e.g. Medicube, Moremo) on phones: the theme gives the
   banner a fixed height (400-450px), so a tall 4:5 picture was cut at the top
   and bottom (the "medicube" logo lost its top). Here each banner takes the
   shape of its own phone picture, so the whole picture shows. Desktop is not
   changed. The CSS part only applies once this has run (class lv-bfit). */
(function () {
  function fit(root) {
    (root || document).querySelectorAll('.t4s-collection-banner2 .t4s-col-banner.t4s_ratioadapt').forEach(function (col) {
      var a = col.querySelector('.t4s_ratio');
      if (!a) return;
      var img = a.querySelector('img.t4s-d-md-none') || a.querySelector('img');
      var w = img && parseFloat(img.getAttribute('width')), h = img && parseFloat(img.getAttribute('height'));
      if (!w || !h) return;
      a.style.setProperty('--aspect-ratioaptmb', (w / h).toFixed(4));
      col.classList.add('lv-bfit');
    });
  }
  fit();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fit(); });
  document.addEventListener('shopify:section:load', function (e) { fit(e.target); });
})();

/* Round 12. Product rows: the slider measures the card height once, when the
   page loads. If the text grows after that (font arrives late, pictures,
   tab switch), the bottom of the cards (the price) was cut off. The height is
   now measured again when fonts and pictures finish and whenever a card's
   content changes size. */
(function () {
  var F = window.Flickityt4s;
  if (!F || !F.data) return;
  var pending = [], raf = 0, watched = new WeakSet();
  function flush() {
    raf = 0;
    var list = pending; pending = [];
    list.forEach(function (el) { var f = F.data(el); if (f && f.isActive) { try { f.resize(); } catch (e) {} } });
  }
  function queue(el) { if (pending.indexOf(el) < 0) pending.push(el); if (!raf) raf = requestAnimationFrame(flush); }
  var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
    entries.forEach(function (en) { var s = en.target.closest('.flickityt4s-enabled'); if (s) queue(s); });
  }) : null;
  function scan(all) {
    document.querySelectorAll('.t4s_box_pr_slider.flickityt4s-enabled').forEach(function (s) {
      if (all) queue(s);
      if (!ro || watched.has(s)) return;
      watched.add(s);
      var infos = s.querySelectorAll('.t4s-product-info');
      for (var i = 0; i < infos.length && i < 6; i++) ro.observe(infos[i]);
    });
  }
  function soon() { scan(false); setTimeout(function () { scan(false); }, 1500); }
  if (document.readyState === 'complete') scan(true); else window.addEventListener('load', function () { scan(true); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { scan(true); });
  document.addEventListener('DOMContentLoaded', soon);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.t4s-tabs-ul, [data-tab-id], .t4s-tab-item')) setTimeout(function () { scan(true); }, 900); }, true);
  document.addEventListener('shopify:section:load', soon);
  var n = 0, t = setInterval(function () { scan(false); if (++n > 8) clearInterval(t); }, 1500);
})();

/* Round 12. Names for screen readers on links and fields that had none:
   category picture tiles, quantity buttons and box, newsletter email box. */
(function () {
  var ar = /^ar/i.test(document.documentElement.getAttribute('lang') || '');
  var T = ar ? { minus: 'إنقاص الكمية', plus: 'زيادة الكمية', qty: 'الكمية' } : { minus: 'Decrease quantity', plus: 'Increase quantity', qty: 'Quantity' };
  function run() {
    document.querySelectorAll('a.t4s_cat_item_link:not([aria-label])').forEach(function (a) {
      var item = a.closest('.t4s-collection-item, .t4s-col-item, [class*=collection-item]');
      var t = item && item.querySelector('.t4s-collection-title');
      var name = t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
      if (name) a.setAttribute('aria-label', name);
    });
    document.querySelectorAll('.t4s-quantity-selector.is--minus:not([aria-label])').forEach(function (b) { b.setAttribute('aria-label', T.minus); });
    document.querySelectorAll('.t4s-quantity-selector.is--plus:not([aria-label])').forEach(function (b) { b.setAttribute('aria-label', T.plus); });
    document.querySelectorAll('input.t4s-quantity-input:not([aria-label])').forEach(function (i) { i.setAttribute('aria-label', T.qty); });
    document.querySelectorAll('input[type=email]:not([aria-label])').forEach(function (i) { if (i.placeholder) i.setAttribute('aria-label', i.placeholder); });
    // Product cards: the see-through link over the whole card gets the product name.
    document.querySelectorAll('a.t4s-full-width-link:not([aria-label])').forEach(function (a) {
      var card = a.closest('.t4s-product');
      var t = card && card.querySelector('.t4s-product-title');
      var name = t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
      if (name) a.setAttribute('aria-label', name);
    });
    // Banner and slideshow pictures with no description: name the link after
    // the page it opens. A banner link that opens nothing stops being a link.
    document.querySelectorAll('.t4s-slideshow-item a.t4s-full-width-link:not([aria-label]), .t4s-banner-inner > a:not([aria-label])').forEach(function (a) {
      if (a.textContent.trim() || a.querySelector('img[alt]:not([alt=""])')) return;
      var href = a.getAttribute('href');
      if (href === '' || href === '#') { a.removeAttribute('href'); return; }
      var seg = '';
      try { seg = decodeURIComponent((href || '').split(/[?#]/)[0].replace(/\/+$/, '').split('/').pop()); } catch (e) {}
      seg = seg.replace(/[-_]+/g, ' ').trim();
      if (seg) a.setAttribute('aria-label', seg);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // Again after load, for product rows that arrive late (recommendations, tabs).
  window.addEventListener('load', function () { run(); setTimeout(run, 2500); setTimeout(run, 6000); });
})();

/* Round 12. The old categories dropdown sits in a header that is hidden on
   every screen, yet the theme downloaded it after the first tap (with 16 code
   errors and broken picture links inside). Skip that download while it is
   hidden. */
(function () {
  document.querySelectorAll('[data-wrapper-categories]').forEach(function (el) {
    if (!el.getClientRects().length) el.removeAttribute('data-wrapper-categories');
  });
})();

/* Round 12. Brand search, second step: when a search word is the start of a
   collection title (e.g. "anua" -> "Anua Skincare Kuwait"), open that
   collection. Exact collection names are already handled in the header code;
   this covers brand collections named differently. Filters, wishlist and
   multi-word product searches are left alone. */
(function () {
  if (!/template-search/.test(document.body.className)) return;
  var p = new URLSearchParams(location.search), q = (p.get('q') || '').trim(), skip = false;
  p.forEach(function (v, k) { if (/^filter\.|^page$|^sort_by$|^view$/.test(k)) skip = true; });
  if (skip || q.length < 3 || q.length > 40 || /^\*|id:/i.test(q)) return;
  function norm(s) { return String(s).toLowerCase().replace(/[ً-ْ]/g, '').replace(/[أإآ]/g, 'ا').replace(/[^\p{L}\p{N}]+/gu, ' ').trim(); }
  var nq = norm(q);
  if (!nq) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // Shopify's suggest service refuses Arabic ("Unsupported buyer locale"), so the
  // lookup is always done in English and the collection opens in the visitor's language.
  fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=collection&resources[limit]=4')
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var cs = (j && j.resources && j.resources.results && j.resources.results.collections) || [];
      for (var i = 0; i < cs.length; i++) {
        var t = norm(cs[i].title);
        if (cs[i].handle && (t === nq || t.indexOf(nq + ' ') === 0)) { location.replace(root + 'collections/' + cs[i].handle); return; }
      }
    }).catch(function () {});
})();
